"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pool = void 0;

var Pool =
/** @class */
function () {
  function Pool() {}

  Pool.prototype.FeatureType = function () {
    return [{
      slug: 'salesforce',
      name: 'Salesforce',
      description: null,
      isSalesforce: true,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'apiaccess',
      name: 'API Access',
      description: null,
      isSalesforce: false,
      isApiAccess: true,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'marketo',
      name: 'Marketo',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: true,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'emailmasking',
      name: 'Email Masking',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: true,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'whitelabeling',
      name: 'White Labeling',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: true,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'agents',
      name: 'Agents',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: true,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'visacheckout',
      name: 'VisaCheckout',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: true,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'canvas',
      name: 'Canvas',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: true,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'shield',
      name: 'Shield',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: true,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'accesscontrol-efx',
      name: 'Access Control (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: true,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'athletebag-efx',
      name: 'Athlete Bag (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: true,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'concierge-efx',
      name: 'Concierge (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: true,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'digitalmemorybank-efx',
      name: 'Digital Memory Bank (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: true,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'guestinfo-efx',
      name: 'Guest Info (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: true,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'messaging-efx',
      name: 'Messaging (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: true,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'smsquiz-efx',
      name: 'SMS Quiz (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: true,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'productpickup-efx',
      name: 'Product Pickup (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: true,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'raffle-efx',
      name: 'Raffle (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: true,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'reservation-efx',
      name: 'Reservation (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: true,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'roamingphotog-efx',
      name: 'Roaming Photog (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: true,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'smartbar-efx',
      name: 'SmartBar (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: true,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'teams-efx',
      name: 'Teams (EFx)',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: true,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'event-app',
      name: 'Event App',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: true,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'child-events',
      name: 'Child Events',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: true,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'waitlist',
      name: 'Waitlist',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: true,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'virbela',
      name: 'Virbela',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: true,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'web-conference',
      name: 'Web Conference',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: true,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'health-pass',
      name: 'Health Pass',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: true,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'question-logic',
      name: 'Question Logic',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: true,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'logi',
      name: 'Logi',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: true,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'exhibitors',
      name: 'Exhibitors',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: true,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'session-management',
      name: 'Session Management',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: true,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'beta-features',
      name: 'Beta Features',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: true,
      isDisablePayments: false,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'disable-payments',
      name: 'Disable Payments',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: true,
      isDayPass: false,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'day-pass',
      name: 'Day Pass',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: true,
      isCustomNikeLocalizedPPToU: false
    }, {
      slug: 'day-pass',
      name: 'Day Pass',
      description: null,
      isSalesforce: false,
      isApiAccess: false,
      isMarketo: false,
      isEmailMasking: false,
      isWhiteLabeling: false,
      isAgents: false,
      isVisaCheckout: false,
      isCanvas: false,
      isShield: false,
      isAccessControlEFx: false,
      isAthleteBagEFx: false,
      isConciergeEFx: false,
      isDigitalMemoryBankEFx: false,
      isGuestInfoEFx: false,
      isMessagingEFx: false,
      isSmsQuizEFx: false,
      isProductPickupEFx: false,
      isRaffleEFx: false,
      isReservationEFx: false,
      isRoamingPhotogEFx: false,
      isSmartBarEFx: false,
      isTeamsEFx: false,
      isEventApp: false,
      isChildEvents: false,
      isWaitlist: false,
      isVirbela: false,
      isWebConference: false,
      isQuestionLogic: false,
      isHealthPass: false,
      isExhibitors: false,
      isLogi: false,
      isSessionManagement: false,
      isBetaFeatures: false,
      isDisablePayments: false,
      isDayPass: true,
      isCustomNikeLocalizedPPToU: false
    }];
  };

  Pool.prototype.PoolAllotmentType = function () {
    return [{
      slug: 'listly',
      name: 'Listly',
      description: null,
      isListly: true,
      isCIO: false,
      isEventFarm: false
    }, {
      slug: 'cio',
      name: 'CIO',
      description: null,
      isListly: false,
      isCIO: true,
      isEventFarm: false
    }, {
      slug: 'eventfarm',
      name: 'EventFarm',
      description: null,
      isListly: false,
      isCIO: false,
      isEventFarm: true
    }];
  };

  Pool.prototype.PoolContactType = function () {
    return [{
      slug: 'full',
      name: 'Team Manager',
      description: null,
      isFull: true,
      isCreate: false
    }, {
      slug: 'create',
      name: 'Event Create Only',
      description: null,
      isFull: false,
      isCreate: true
    }];
  };

  Pool.prototype.PoolContractType = function () {
    return [{
      slug: 'cio',
      name: 'CIO',
      description: null,
      isCIO: true,
      isIntro: false,
      isTrial: false,
      isPro: false,
      isPremier: false,
      isPremierPlus: false,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'intro',
      name: 'Intro',
      description: null,
      isCIO: false,
      isIntro: true,
      isTrial: false,
      isPro: false,
      isPremier: false,
      isPremierPlus: false,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'trial',
      name: 'Trial',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: true,
      isPro: false,
      isPremier: false,
      isPremierPlus: false,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'pro',
      name: 'Pro',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: false,
      isPro: true,
      isPremier: false,
      isPremierPlus: false,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'premier',
      name: 'Premier',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: false,
      isPro: false,
      isPremier: true,
      isPremierPlus: false,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'premierPlus',
      name: 'Premier Plus',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: false,
      isPro: false,
      isPremier: false,
      isPremierPlus: true,
      isCustom: false,
      isInternal: false
    }, {
      slug: 'custom',
      name: 'Custom',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: false,
      isPro: false,
      isPremier: false,
      isPremierPlus: false,
      isCustom: true,
      isInternal: false
    }, {
      slug: 'internal',
      name: 'Internal',
      description: null,
      isCIO: false,
      isIntro: false,
      isTrial: false,
      isPro: false,
      isPremier: false,
      isPremierPlus: false,
      isCustom: false,
      isInternal: true
    }];
  };

  Pool.prototype.PoolFileCategoryType = function () {
    return [{
      slug: 'profile',
      name: 'Profile',
      description: null,
      isProfile: true,
      isEFx: false,
      isOther: false
    }, {
      slug: 'efx',
      name: 'EFx',
      description: null,
      isProfile: false,
      isEFx: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isProfile: false,
      isEFx: false,
      isOther: true
    }];
  };

  Pool.prototype.PoolImageType = function () {
    return [{
      slug: 'profile',
      name: 'Profile',
      description: null,
      isProfile: true,
      isEFx: false,
      isOther: false
    }, {
      slug: 'efx',
      name: 'EFx',
      description: null,
      isProfile: false,
      isEFx: true,
      isOther: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isProfile: false,
      isEFx: false,
      isOther: true
    }];
  };

  Pool.prototype.PoolWebhookType = function () {
    return [{
      slug: 'checkin',
      name: 'Check-In',
      description: null,
      isCheckin: true
    }];
  };

  return Pool;
}();

exports.Pool = Pool;